import { qcls, qfonts } from './quizTheme'

interface Props {
  onRestart: () => void
}

export default function ThankYouPage({ onRestart }: Props) {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="bg-black flex-1 flex flex-col items-center justify-center px-6 py-20 text-center relative overflow-hidden">
        {/* Yellow accent bar at top */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-brand-yellow" />

        <div className="flex flex-col items-center">
          <div className="w-24 h-24 bg-brand-yellow rounded-full flex items-center justify-center mb-8 shadow-[0_0_40px_rgba(255,219,0,0.3)]">
            <svg className="w-12 h-12 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <p className="text-brand-yellow text-xs tracking-[0.08em] font-semibold mb-3">
            Assessment complete
          </p>
          <h1 className={`text-[32px] font-black text-white leading-tight mb-4 ${qfonts.heading}`}>
            You're all done!
          </h1>
          <div className="max-w-md space-y-4 mb-10">
            <p className={`text-white/50 text-base leading-relaxed ${qfonts.body}`}>
              Thank you for completing the assessment. Your responses have been recorded and your competence profile is being calculated.
            </p>
            <p className={`text-white/50 text-base leading-relaxed ${qfonts.body}`}>
              A personalised report will be prepared based on your answers.
            </p>
          </div>

          <div className="flex justify-center">
            <button
              onClick={onRestart}
              className="px-8 py-4 border-2 bg-brand-yellow font-bold hover:brightness-95 active:scale-[0.99] transition-all"
              style={{ color: 'rgb(26, 30, 43)', borderColor: 'rgb(26, 30, 43)', fontFamily: 'RobotoMono, Arial, sans-serif', fontSize: 16, fontWeight: 700 }}
            >
              Start a new session
            </button>
          </div>
        </div>
      </div>

      <div className="bg-black w-full pb-8 flex justify-center">
        <p className="text-xs text-white/40 text-center">
          &copy; {new Date().getFullYear()} UNSW. All rights reserved.
        </p>
      </div>
    </div>
  )
}
